import { ProfileMenu } from '@ap/header';

export function getProfileHeader(userName: string | null, companyName: string | null, unreadMessagesSize: number): ProfileMenu {
    return {
        name: userName,
        subtitle: companyName,
        notifications: unreadMessagesSize,
        groups: [
            {
                title: 'mijn.template.header.inbox.title',
                items: [
                    {
                        title: 'mijn.template.header.inbox.messages.title',
                        icon: 'envelope',
                        notifications: unreadMessagesSize,
                        routeKey: 'mijn.template.header.inbox.messages.routeKey'
                    },
                    {
                        title: 'mijn.template.header.inbox.documents.title',
                        subtitle: 'mijn.template.header.inbox.documents.subtitle',
                        icon: 'file-default',
                        routeKey: 'mijn.template.header.inbox.documents.routeKey'
                    }
                ]
            },
            {
                title: 'mijn.template.header.settings.title',
                items: [
                    {
                        title: 'mijn.template.header.settings.safetyAccess.title',
                        subtitle: 'mijn.template.header.settings.safetyAccess.subtitle',
                        icon: 'lock-alt',
                        routeKey: 'mijn.template.header.settings.safetyAccess.routeKey'
                    },
                    {
                        title: 'mijn.template.header.settings.personalData.title',
                        subtitle: 'mijn.template.header.settings.personalData.subtitle',
                        icon: 'contact',
                        routeKey: 'mijn.template.header.settings.personalData.routeKey'
                    },
                    {
                        title: 'mijn.template.header.settings.businessData.title',
                        subtitle: 'mijn.template.header.settings.businessData.subtitle',
                        icon: 'inzicht-bankkosten',
                        routeKey: 'mijn.template.header.settings.businessData.routeKey'
                    },
                    {
                        title: 'mijn.template.header.settings.alerts.title',
                        subtitle: 'mijn.template.header.settings.alerts.subtitle',
                        icon: 'bell',
                        routeKey: 'mijn.template.header.settings.alerts.routeKey'
                    },
                    {
                        title: 'mijn.template.header.settings.messagePreferences.title',
                        subtitle: 'mijn.template.header.settings.messagePreferences.subtitle',
                        icon: 'bullhorn',
                        routeKey: 'mijn.template.header.settings.messagePreferences.routeKey'
                    },
                    {
                        title: 'mijn.template.header.settings.privacy.title',
                        icon: 'privacy',
                        routeKey: 'mijn.template.header.settings.privacy.routeKey'
                    }
                ]
            }
        ]
    };
}
